import { useState } from 'react'
import ExceptionalDate from './ExceptionalDate'
import EditExceptionalDateModal from 'pages/Modals/EditExceptionalDateModal'

import {
  Container,
  SubTitle,
  InfoText,
  LabelRow
} from './styles'

export default function ExceptionalDateList ({
  exceptionalDates = [],
  onEdit: handleEdit,
  onDelete: handleDelete
}) {
  const [exceptionalDateData, setExceptionalDateData] = useState (null)
  const [showEditExceptionalDateModal, setShowEditExceptionalDateModal] = useState (false)

  const editExceptionalDate = date => {
    setExceptionalDateData (date)
    toggleEditExceptionalDateModal ()
  }

  const toggleEditExceptionalDateModal = () => (
    setShowEditExceptionalDateModal (!showEditExceptionalDateModal)
  )

  if (exceptionalDates.length === 0) return (
    <Container>
      <InfoText>Nenhuma data excepcional encontrada</InfoText>
    </Container>
  )

  return (
    <Container>
      <LabelRow>
        <SubTitle>Descrição</SubTitle>
        <SubTitle>Data inicial</SubTitle>
        <SubTitle>Data final</SubTitle>
        <SubTitle>Período</SubTitle>
        <SubTitle>Horário inicial</SubTitle>
        <SubTitle>Horário final</SubTitle>
        <SubTitle>Ações</SubTitle>
      </LabelRow>
      {exceptionalDates.map (date => (
        <ExceptionalDate
          key={date.id}
          data={date}
          onEdit={editExceptionalDate}
          onDelete={handleDelete}
        />
      ))}
      {!!exceptionalDateData && (
        <EditExceptionalDateModal
          visible={showEditExceptionalDateModal}
          data={exceptionalDateData}
          onConfirm={handleEdit}
          onClose={toggleEditExceptionalDateModal}
        />
      )}
    </Container>
  )
}
